import { Chip as MUIChip } from "@mui/material";
import ThemeContext from "components/app/Context";
import { useContext } from "react";
import { tokens } from "styles/Tokens";
interface Props {
  label: any;
  icon?: any;
  iconAtStart?: boolean;
  variant?: "filled" | "outlined";
  color?: string;
  size?: "small" | "medium";
  sx?: object;
  backgroundColor?: string;
  borderColor?: string;
}

function Chip(props: Props) {
  const { isMobileScreen } = useContext(ThemeContext);

  const {
    label,
    variant = "outlined",
    color,
    backgroundColor,
    borderColor,
    size = isMobileScreen ? "small" : "medium",
    icon,
    iconAtStart = false,
    sx
  } = props;

  return (
    <MUIChip
      sx={{
        fontWeight: "700",
        height: "24px",
        padding: iconAtStart ? "0px 12px 0px 8px" : "0px 12px",
        borderRadius: "11px",
        border: borderColor ? `1px solid ${borderColor}` : "unset",
        color: color ?? tokens.Text.General.Color,
        backgroundColor: backgroundColor,
        gap: "4px",
        "&.MuiChip-sizeSmall": {
          display: "flex",
          flexWrap: "wrap",
          fontSize: "12px"
        },
        "&.MuiChip-sizeMedium": {
          fontSize: "14px"
        },
        "& .MuiChip-label": {
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          height: "100%",
          paddingX: "0"
        },
        "& .MuiChip-icon": {
          marginRight: "4px",
          order: iconAtStart ? 0 : 2
        },
        ...sx
      }}
      size={size}
      label={label}
      variant={variant}
      icon={icon}
    />
  );
}

export default Chip;
